"use strict";
/* eslint-disable no-underscore-dangle */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.BaseSequenceBlock = exports.BaseInsertionControl = exports.BaseSequenceChild = void 0;
/* global $ */
var events_1 = __importDefault(require("events"));
var text_1 = require("../../../utils/text");
var ActionButton = /** @class */ (function () {
    function ActionButton(sequenceChild) {
        this.sequenceChild = sequenceChild;
    }
    ActionButton.prototype.render = function (container) {
        var _this = this;
        var label = this.sequenceChild.strings[this.labelIdentifier] || this.labelIdentifier;
        this.dom = $("\n      <button type=\"button\" class=\"c-sf-block__actions__single\" title=\"" + text_1.escapeHtml(label) + "\">\n        <svg class=\"icon icon-" + text_1.escapeHtml(this.icon) + "\" aria-hidden=\"true\">\n          <use href=\"#icon-" + text_1.escapeHtml(this.icon) + "\"></use>\n        </svg>\n      </button>\n    ");
        this.dom.on('click', function () {
            if (_this.onClick)
                _this.onClick();
            return false; // don't propagate to header's onclick event (which collapses the block)
        });
        $(container).append(this.dom);
        if (this.enableEvent) {
            this.sequenceChild.on(this.enableEvent, function () {
                _this.enable();
            });
        }
        if (this.disableEvent) {
            this.sequenceChild.on(this.disableEvent, function () {
                _this.disable();
            });
        }
        if (this.initiallyDisabled) {
            this.disable();
        }
    };
    ActionButton.prototype.enable = function () {
        this.dom.removeAttr('disabled');
    };
    ActionButton.prototype.disable = function () {
        this.dom.attr('disabled', 'true');
    };
    return ActionButton;
}());
var MoveUpButton = /** @class */ (function (_super) {
    __extends(MoveUpButton, _super);
    function MoveUpButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enableEvent = 'enableMoveUp';
        _this.disableEvent = 'disableMoveUp';
        _this.initiallyDisabled = true;
        _this.icon = 'arrow-up';
        _this.labelIdentifier = 'MOVE_UP';
        return _this;
    }
    MoveUpButton.prototype.onClick = function () {
        this.sequenceChild.moveUp();
    };
    return MoveUpButton;
}(ActionButton));
var MoveDownButton = /** @class */ (function (_super) {
    __extends(MoveDownButton, _super);
    function MoveDownButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enableEvent = 'enableMoveDown';
        _this.disableEvent = 'disableMoveDown';
        _this.initiallyDisabled = true;
        _this.icon = 'arrow-down';
        _this.labelIdentifier = 'MOVE_DOWN';
        return _this;
    }
    MoveDownButton.prototype.onClick = function () {
        this.sequenceChild.moveDown();
    };
    return MoveDownButton;
}(ActionButton));
var DuplicateButton = /** @class */ (function (_super) {
    __extends(DuplicateButton, _super);
    function DuplicateButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enableEvent = 'enableDuplication';
        _this.disableEvent = 'disableDuplication';
        _this.icon = 'duplicate';
        _this.labelIdentifier = 'DUPLICATE';
        return _this;
    }
    DuplicateButton.prototype.onClick = function () {
        this.sequenceChild.duplicate({ animate: true });
    };
    return DuplicateButton;
}(ActionButton));
var DeleteButton = /** @class */ (function (_super) {
    __extends(DeleteButton, _super);
    function DeleteButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.icon = 'bin';
        _this.labelIdentifier = 'DELETE';
        return _this;
    }
    DeleteButton.prototype.onClick = function () {
        this.sequenceChild["delete"]({ animate: true });
    };
    return DeleteButton;
}(ActionButton));
var BaseSequenceChild = /** @class */ (function (_super) {
    __extends(BaseSequenceChild, _super);
    function BaseSequenceChild(blockDef, placeholder, prefix, index, id, initialState, sequence, opts) {
        var _this = this;
        _this.blockDef = blockDef;
        _this.type = blockDef.name;
        _this.prefix = prefix;
        _this.index = index;
        _this.id = id;
        _this.sequence = sequence;
        var animate = opts && opts.animate;
        _this.collapsed = opts && opts.collapsed;
        _this.strings = (opts && opts.strings) || {};
        var dom = $("\n      <div aria-hidden=\"false\" " + (_this.id ? "data-contentpath=\"" + text_1.escapeHtml(_this.id) + "\"" : 'data-contentpath-disabled') + ">\n        <input type=\"hidden\"  name=\"" + _this.prefix + "-deleted\" value=\"\">\n        <input type=\"hidden\" name=\"" + _this.prefix + "-order\" value=\"" + index + "\">\n        <input type=\"hidden\" name=\"" + _this.prefix + "-type\" value=\"" + text_1.escapeHtml(_this.type || '') + "\">\n        <input type=\"hidden\" name=\"" + _this.prefix + "-id\" value=\"" + text_1.escapeHtml(_this.id || '') + "\">\n\n        <div>\n          <div class=\"c-sf-container__block-container\">\n            <div class=\"c-sf-block\">\n              <div data-block-header class=\"c-sf-block__header c-sf-block__header--collapsible\">\n                <svg class=\"icon icon-" + text_1.escapeHtml(_this.blockDef.meta.icon) + " c-sf-block__header__icon\" aria-hidden=\"true\">\n                  <use href=\"#icon-" + text_1.escapeHtml(_this.blockDef.meta.icon) + "\"></use>\n                </svg>\n                <h3 data-block-title class=\"c-sf-block__header__title\"></h3>\n                <div class=\"c-sf-block__actions\" data-block-actions>\n                  <span class=\"c-sf-block__type\">" + text_1.escapeHtml(_this.blockDef.meta.label) + "</span>\n                </div>\n              </div>\n              <div data-block-content class=\"c-sf-block__content\" aria-hidden=\"false\">\n                <div class=\"c-sf-block__content-inner\">\n                  <div data-streamfield-block></div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ");
        $(placeholder).replaceWith(dom);
        _this.element = dom.get(0);
        var blockElement = dom.find('[data-streamfield-block]').get(0);
        _this.actionsContainerElement = dom.find('[data-block-actions]').get(0);
        _this.titleElement = dom.find('[data-block-title]');
        _this.contentElement = dom.find('[data-block-content]');
        _this.deletedInput = dom.find("input[name=\"" + _this.prefix + "-deleted\"]");
        _this.indexInput = dom.find("input[name=\"" + _this.prefix + "-order\"]");
        dom.find('[data-block-header]').click(function () {
            _this.toggleCollapsedState();
        });
        _this.addActionButton(new MoveUpButton(_this));
        _this.addActionButton(new MoveDownButton(_this));
        _this.addActionButton(new DuplicateButton(_this));
        _this.addActionButton(new DeleteButton(_this));
        _this.block = _this.blockDef.render(blockElement, _this.prefix + '-value', initialState);
        if (_this.collapsed) {
            _this.collapse();
        }
        if (animate) {
            dom.hide();
            setTimeout(function () {
                dom.slideDown();
            }, 10);
        }
        return _this;
    }
    BaseSequenceChild.prototype.addActionButton = function (button) {
        button.render(this.actionsContainerElement);
    };
    BaseSequenceChild.prototype.moveUp = function () {
        this.sequence.moveBlockUp(this.index);
    };
    BaseSequenceChild.prototype.moveDown = function () {
        this.sequence.moveBlockDown(this.index);
    };
    BaseSequenceChild.prototype.duplicate = function (opts) {
        this.sequence.duplicateBlock(this.index, opts);
    };
    BaseSequenceChild.prototype["delete"] = function (opts) {
        this.sequence.deleteBlock(this.index, opts);
    };
    BaseSequenceChild.prototype.markDeleted = function (_a) {
        var _b;
        var _c = _a.animate, animate = _c === void 0 ? false : _c;
        this.deletedInput.val('1');
        if (animate) {
            $(this.element).slideUp().dequeue()
                .fadeOut()
                .attr('aria-hidden', 'true');
        }
        else {
            $(this.element).hide().attr('aria-hidden', 'true');
        }
        // Inform the comment app that the content path of this block is no longer valid
        // This will hide any comments that were previously on the block
        var contentPath = (_b = window.comments) === null || _b === void 0 ? void 0 : _b.getContentPath(this.element);
        if (contentPath && window.comments.commentApp) {
            window.comments.commentApp.invalidateContentPath(contentPath);
        }
    };
    BaseSequenceChild.prototype.enableDuplication = function () {
        this.emit('enableDuplication');
    };
    BaseSequenceChild.prototype.disableDuplication = function () {
        this.emit('disableDuplication');
    };
    BaseSequenceChild.prototype.enableMoveUp = function () {
        this.emit('enableMoveUp');
    };
    BaseSequenceChild.prototype.disableMoveUp = function () {
        this.emit('disableMoveUp');
    };
    BaseSequenceChild.prototype.enableMoveDown = function () {
        this.emit('enableMoveDown');
    };
    BaseSequenceChild.prototype.disableMoveDown = function () {
        this.emit('disableMoveDown');
    };
    BaseSequenceChild.prototype.setIndex = function (newIndex) {
        this.index = newIndex;
        this.indexInput.val(newIndex);
    };
    BaseSequenceChild.prototype.setError = function (error) {
        this.block.setError(error);
    };
    BaseSequenceChild.prototype.focus = function (opts) {
        this.block.focus(opts);
    };
    BaseSequenceChild.prototype.getTextLabel = function (opts) {
        if (this.block.getTextLabel) {
            return this.block.getTextLabel(opts);
        }
        return null;
    };
    BaseSequenceChild.prototype.collapse = function () {
        this.contentElement.hide().attr('aria-hidden', 'true');
        var label = this.getTextLabel({ maxLength: 50 });
        this.titleElement.text(label || '');
        this.collapsed = true;
        this.contentElement.get(0).dispatchEvent(new CustomEvent('commentAnchorVisibilityChange', { bubbles: true }));
    };
    BaseSequenceChild.prototype.expand = function () {
        this.contentElement.show().attr('aria-hidden', 'false');
        this.titleElement.text('');
        this.collapsed = false;
        this.contentElement.get(0).dispatchEvent(new CustomEvent('commentAnchorVisibilityChange', { bubbles: true }));
    };
    BaseSequenceChild.prototype.toggleCollapsedState = function () {
        if (this.collapsed) {
            this.expand();
        }
        else {
            this.collapse();
        }
    };
    return BaseSequenceChild;
}(events_1["default"]));
exports.BaseSequenceChild = BaseSequenceChild;
var BaseInsertionControl = /** @class */ (function () {
    /* Base class for controls that appear between blocks in a sequence, to allow inserting new
    blocks at that point. Subclasses should render an HTML structure with a single root element
    (replacing the placeholder passed to the constructor) and set it as this.element.
    When the user requests to insert a block, we call onRequestInsert passing the index number
    and a dict of control-specific options. */
    function BaseInsertionControl(placeholder, opts) {
        this.index = opts && opts.index;
        this.onRequestInsert = opts && opts.onRequestInsert;
    }
    BaseInsertionControl.prototype.setIndex = function (newIndex) {
        this.index = newIndex;
    };
    BaseInsertionControl.prototype["delete"] = function (_a) {
        var _b = _a.animate, animate = _b === void 0 ? false : _b;
        if (animate) {
            $(this.element).slideUp().attr('aria-hidden', 'true');
        }
        else {
            $(this.element).hide().attr('aria-hidden', 'true');
        }
    };
    return BaseInsertionControl;
}());
exports.BaseInsertionControl = BaseInsertionControl;
var BaseSequenceBlock = /** @class */ (function () {
    function BaseSequenceBlock() {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BaseSequenceBlock.prototype._createChild = function (blockDef, placeholder, prefix, index, id, initialState, sequence, opts) {
        throw new Error('not implemented');
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BaseSequenceBlock.prototype._createInsertionControl = function (placeholder, opts) {
        throw new Error('not implemented');
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BaseSequenceBlock.prototype._getChildDataForInsertion = function (opts) {
        throw new Error('not implemented');
    };
    BaseSequenceBlock.prototype.clear = function () {
        var _this = this;
        this.countInput.val(0);
        this.sequenceContainer.empty();
        this.children = [];
        this.blockCounter = 0;
        // Create initial insertion control
        var placeholder = document.createElement('div');
        this.sequenceContainer.append(placeholder);
        this.inserters = [
            this._createInsertionControl(placeholder, {
                index: 0,
                onRequestInsert: function (newIndex, opts) {
                    _this._onRequestInsert(newIndex, opts);
                },
                strings: this.blockDef.meta.strings,
            })
        ];
        this.blockCountChanged();
    };
    BaseSequenceBlock.prototype._onRequestInsert = function (index, opts) {
        /* handler for an 'insert new block' action */
        var _a = __read(this._getChildDataForInsertion(opts), 3), blockDef = _a[0], initialState = _a[1], id = _a[2];
        var newChild = this._insert(blockDef, initialState, id || null, index, { animate: true });
        // focus the newly added field if we can do so without obtrusive UI behaviour
        newChild.focus({ soft: true });
    };
    BaseSequenceBlock.prototype.blockCountChanged = function () {
        /* Called whenever the block count has changed; subclasses can override this to apply
        checks on max block count and disable insert / duplicate controls accordingly */
    };
    BaseSequenceBlock.prototype._insert = function (childBlockDef, initialState, id, index, opts) {
        var _this = this;
        var prefix = this.prefix + '-' + this.blockCounter;
        var animate = opts && opts.animate;
        var collapsed = opts && opts.collapsed;
        this.blockCounter++;
        /*
        a new inserter and block will be inserted AFTER the inserter with the given index;
        e.g if there are 3 blocks the children of sequenceContainer will be
        [inserter 0, block 0, inserter 1, block 1, inserter 2, block 2, inserter 3]
        and inserting a new block at index 1 will create a new block 1 and inserter 2 after the
        current inserter 1, and increment everything after that point
        */
        var existingInserterElement = this.inserters[index].element;
        var blockPlaceholder = document.createElement('div');
        var inserterPlaceholder = document.createElement('div');
        $(blockPlaceholder).insertAfter(existingInserterElement);
        $(inserterPlaceholder).insertAfter(blockPlaceholder);
        /* shuffle up indexes of all blocks / inserters above this index */
        for (var i = index; i < this.children.length; i++) {
            this.children[i].setIndex(i + 1);
        }
        for (var i = index + 1; i < this.inserters.length; i++) {
            this.inserters[i].setIndex(i + 1);
        }
        var child = this._createChild(childBlockDef, blockPlaceholder, prefix, index, id, initialState, this, {
            animate: animate,
            collapsed: collapsed,
            strings: this.blockDef.meta.strings,
        });
        this.children.splice(index, 0, child);
        var inserter = this._createInsertionControl(inserterPlaceholder, {
            index: index + 1,
            onRequestInsert: function (newIndex, inserterOpts) {
                _this._onRequestInsert(newIndex, inserterOpts);
            },
            strings: this.blockDef.meta.strings,
            animate: animate,
        });
        this.inserters.splice(index + 1, 0, inserter);
        this.countInput.val(this.blockCounter);
        var isFirstChild = (index === 0);
        var isLastChild = (index === this.children.length - 1);
        if (!isFirstChild) {
            child.enableMoveUp();
            if (isLastChild) {
                /* previous child (which was previously the last one) can now move down */
                this.children[index - 1].enableMoveDown();
            }
        }
        if (!isLastChild) {
            child.enableMoveDown();
            if (isFirstChild) {
                /* next child (which was previously the first one) can now move up */
                this.children[index + 1].enableMoveUp();
            }
        }
        this.blockCountChanged();
        return child;
    };
    BaseSequenceBlock.prototype.deleteBlock = function (index, opts) {
        var animate = opts && opts.animate;
        this.children[index].markDeleted({ animate: animate });
        this.inserters[index]["delete"]({ animate: animate });
        this.children.splice(index, 1);
        this.inserters.splice(index, 1);
        /* index numbers of children / inserters above this index now need updating to match
        their array indexes */
        for (var i = index; i < this.children.length; i++) {
            this.children[i].setIndex(i);
        }
        for (var i = index; i < this.inserters.length; i++) {
            this.inserters[i].setIndex(i);
        }
        if (index === 0 && this.children.length > 0) {
            /* we have removed the first child; the new first child cannot be moved up */
            this.children[0].disableMoveUp();
        }
        if (index === this.children.length && this.children.length > 0) {
            /* we have removed the last child; the new last child cannot be moved down */
            this.children[this.children.length - 1].disableMoveDown();
        }
        this.blockCountChanged();
    };
    BaseSequenceBlock.prototype.moveBlock = function (oldIndex, newIndex) {
        if (oldIndex === newIndex)
            return;
        var inserterToMove = this.inserters[oldIndex];
        var childToMove = this.children[oldIndex];
        /* move HTML elements */
        if (newIndex > oldIndex) {
            $(inserterToMove.element).insertAfter(this.children[newIndex].element);
        }
        else {
            $(inserterToMove.element).insertBefore(this.inserters[newIndex].element);
        }
        $(childToMove.element).insertAfter(inserterToMove.element);
        /* reorder items in the `inserters` and `children` arrays */
        this.inserters.splice(oldIndex, 1);
        this.inserters.splice(newIndex, 0, inserterToMove);
        this.children.splice(oldIndex, 1);
        this.children.splice(newIndex, 0, childToMove);
        /* update index properties of moved items */
        if (newIndex > oldIndex) {
            for (var i = oldIndex; i <= newIndex; i++) {
                this.inserters[i].setIndex(i);
                this.children[i].setIndex(i);
            }
        }
        else {
            for (var i = newIndex; i <= oldIndex; i++) {
                this.inserters[i].setIndex(i);
                this.children[i].setIndex(i);
            }
        }
        /* enable/disable up/down arrows as required */
        var maxIndex = this.children.length - 1;
        if (oldIndex === 0) {
            childToMove.enableMoveUp();
            this.children[0].disableMoveUp();
        }
        if (oldIndex === maxIndex) {
            childToMove.enableMoveDown();
            this.children[maxIndex].disableMoveDown();
        }
        if (newIndex === 0) {
            childToMove.disableMoveUp();
            this.children[1].enableMoveUp();
        }
        if (newIndex === maxIndex) {
            childToMove.disableMoveDown();
            this.children[maxIndex - 1].enableMoveDown();
        }
    };
    BaseSequenceBlock.prototype.moveBlockUp = function (index) {
        this.moveBlock(index, index - 1);
    };
    BaseSequenceBlock.prototype.moveBlockDown = function (index) {
        this.moveBlock(index, index + 1);
    };
    BaseSequenceBlock.prototype.setState = function (values) {
        var _this = this;
        this.clear();
        values.forEach(function (val, i) {
            _this.insert(val, i);
        });
    };
    BaseSequenceBlock.prototype.getState = function () {
        return this.children.map(function (child) { return child.getState(); });
    };
    BaseSequenceBlock.prototype.getValue = function () {
        return this.children.map(function (child) { return child.getValue(); });
    };
    BaseSequenceBlock.prototype.getTextLabel = function (opts) {
        var e_1, _a;
        /* Use as many child text labels as we can fit into maxLength */
        var maxLength = opts && opts.maxLength;
        var result = '';
        try {
            for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                var childLabel = child.getTextLabel({ maxLength: maxLength });
                if (childLabel) {
                    if (!result) {
                        // always use the first child, truncated as necessary
                        result = childLabel;
                    }
                    else {
                        var newResult = (result + ', ' + childLabel);
                        if (maxLength && newResult.length > maxLength - 1) {
                            // too long, so don't add this; return the current list with an ellipsis instead
                            if (!result.endsWith('…'))
                                result += '…';
                            return result;
                        }
                        result = newResult;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    };
    BaseSequenceBlock.prototype.focus = function (opts) {
        if (this.children.length) {
            this.children[0].focus(opts);
        }
    };
    return BaseSequenceBlock;
}());
exports.BaseSequenceBlock = BaseSequenceBlock;
